
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p373839333138763776',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})

